module.exports = __webpack_public_path__ + "ff5e45b3af3d5fb6b8b6336f86d0c84c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/Exhibition_video_1.jpg
// module id = 878
// module chunks = 0